import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  NpAvailableTimesRequest,
  NpAvailableTimesResponse,
  NpScheduleSessionsRequest,
  NpScheduleSessionsResponse,
} from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { postNpAvailableTimes, postNpScheduleSessions } from '../../../common/http/data/npTesting'

export const GET_NP_AVAILABLE_TIMES = 'GET_NP_AVAILABLE_TIMES'

export const getNpAvailableTimes = createAsyncThunk<NpAvailableTimesResponse, NpAvailableTimesRequest>(
  GET_NP_AVAILABLE_TIMES,
  async (request, { rejectWithValue }) => {
    try {
      const response = await postNpAvailableTimes(request)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const CLEAR_NP_AVAILABLE_TIMES = 'CLEAR_NP_AVAILABLE_TIMES'
export const clearNpAvailableTimes = () => ({ type: CLEAR_NP_AVAILABLE_TIMES })

export const GET_NP_AVAILABLE_TIMES_FULFILLED = getNpAvailableTimes.fulfilled.type
export const GET_NP_AVAILABLE_TIMES_PENDING = getNpAvailableTimes.pending.type
export const GET_NP_AVAILABLE_TIMES_REJECTED = getNpAvailableTimes.rejected.type

export const SCHEDULE_NP_SESSIONS = 'SCHEDULE_NP_SESSIONS'

export const scheduleNpSessions = createAsyncThunk<
  NpScheduleSessionsResponse,
  { userLyraId: string; request: NpScheduleSessionsRequest }
>(SCHEDULE_NP_SESSIONS, async ({ userLyraId, request }, { rejectWithValue }) => {
  try {
    const response = await postNpScheduleSessions(userLyraId, request)
    return response.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const CLEAR_NP_SCHEDULED_SESSIONS = 'CLEAR_NP_SCHEDULED_SESSIONS'
export const clearNpScheduledSessions = () => ({ type: CLEAR_NP_SCHEDULED_SESSIONS })

export const SCHEDULE_NP_SESSIONS_FULFILLED = scheduleNpSessions.fulfilled.type
export const SCHEDULE_NP_SESSIONS_PENDING = scheduleNpSessions.pending.type
export const SCHEDULE_NP_SESSIONS_REJECTED = scheduleNpSessions.rejected.type
